/*global VeloxWebView*/


/**
 * Extension to search cities in ZIP Codes
 */
var extension = {} ;
extension.name = "electrolyzer-field" ;

//must run after fields
extension.mustRunAfter = ["fields", "country"] ;

var COUNTRY_AVAILABILITY = {
    "SALT_RELAX" :       { FR: true, DE: false, ES: true, GB: true}, 
    "SALT_RELAX_PRO" :   { FR: true, DE: true, ES: true, GB: true}, 
    "SALT_RELAX_PLUS" :  { FR: true, DE: false,ES: true, GB: true}, 
    "SALT_RELAX_POWER" : { FR: true, DE: true,ES: true, GB: true},
    "AUTOMATIC_SALT" :   { FR: false, DE: false,ES: false, GB: false} , 
    "AUTOMATIC_SALT_AS5" :   { FR: true, DE: true,ES: true, GB: true}  ,
    "AUTOMATIC_SALT_AS7" :   { FR: true, DE: true,ES: true, GB: true}  ,
};


function computeOptions(){
    return Object.keys(COUNTRY_AVAILABILITY).filter(function(p){
        //filter by country availability
        return COUNTRY_AVAILABILITY[p][VeloxWebView.country.get()] ;
    }).concat(["OTHER"]).map(function(p){
        return {
            id: p,
            label: VeloxWebView.tr("fields.values.pool.p_electrolyzer."+p)
        } ;
    }) ;
}

extension.init = function(){
    var view = this ;
    view.on("initDone", function(){
        var electEl = view.viewRootEl.querySelector('[data-field-def="pool.p_electrolyzer"]');
        var volumnEl = view.viewRootEl.querySelector('[data-field-def="pool.p_volume"]');
        var saltRateEl = view.viewRootEl.querySelector('[data-field-def="pool.p_disinf_salt_rate"]');
        if(!electEl){
            electEl = view.viewRootEl.querySelector('[data-field-def="diag.p_electrolyzer"]');
            volumnEl = view.viewRootEl.querySelector('[data-field-def="diag.p_volume"]');
            saltRateEl = view.viewRootEl.querySelector('[data-field-def="diag.p_disinf_salt_rate"]');
        }
        if(electEl && saltRateEl){
            function onChange(){
                var elect = electEl.getValue() ;
                var volume = volumnEl.getValue() ;
                if(elect === "SALT_RELAX"){
                    saltRateEl.setValue(4) ;
                }else if(elect === "SALT_RELAX_PRO"){
                    if(volume < 45){
                        saltRateEl.setValue(2) ;
                    }else{
                        saltRateEl.setValue(3.5) ;
                    }
                }else if(elect === "AUTOMATIC_SALT"){
                    if(volume < 45){
                        saltRateEl.setValue(2) ;
                    }else{
                        saltRateEl.setValue(3.5) ;
                    }
                }else if(elect === "AUTOMATIC_SALT_AS5"){
                    if(volume < 45){
                        saltRateEl.setValue(2) ;
                    }else{
                        saltRateEl.setValue(3.5) ;
                    }
                }else if(elect === "AUTOMATIC_SALT_AS7"){
                    if(volume < 65){
                        saltRateEl.setValue(2) ;
                    }else{
                        saltRateEl.setValue(3.5) ;
                    }
                }else if(elect === "SALT_RELAX_PLUS"){
                    saltRateEl.setValue(4) ;
                }else if(elect === "SALT_RELAX_POWER"){
                    if(volume < 65){
                        saltRateEl.setValue(2) ;
                    }else{
                        saltRateEl.setValue(3.5) ;
                    }
                }else{
                    saltRateEl.setValue("") ;
                }
            }
            electEl.addEventListener("change", onChange) ;
            volumnEl.addEventListener("change", onChange) ;
            view.on("render", function(){
                electEl.setOptions(computeOptions()) ;
            }) ;
        }   


        var spaElectEl = view.viewRootEl.querySelector('[data-field-def="spa.s_electrolyzer"]');
        var spaVolumeEl = view.viewRootEl.querySelector('[data-field-def="spa.s_volume"]');
        var spaSaltRateEl = view.viewRootEl.querySelector('[data-field-def="spa.s_disinf_salt_rate"]');
        if(!spaElectEl){
            spaElectEl = view.viewRootEl.querySelector('[data-field-def="diag.s_electrolyzer"]');
            spaVolumeEl = view.viewRootEl.querySelector('[data-field-def="diag.s_volume"]');
            spaSaltRateEl = view.viewRootEl.querySelector('[data-field-def="diag.s_disinf_salt_rate"]');
        }
        if(spaElectEl && spaSaltRateEl){
            function onChange(){
                var elect = spaElectEl.getValue() ;
                var volume = spaVolumeEl.getValue() ;
                if(elect === "SALT_RELAX"){
                    spaSaltRateEl.setValue(4) ;
                }else if(elect === "SALT_RELAX_PRO"){
                    if(volume < 45){
                        spaSaltRateEl.setValue(2) ;
                    }else{
                        spaSaltRateEl.setValue(3.5) ;
                    }
                }else if(elect === "AUTOMATIC_SALT"){
                    if(volume < 45){
                        spaSaltRateEl.setValue(2) ;
                    }else{
                        spaSaltRateEl.setValue(3.5) ;
                    }
                }else if(elect === "AUTOMATIC_SALT_AS5"){
                    if(volume < 45){
                        spaSaltRateEl.setValue(2) ;
                    }else{
                        spaSaltRateEl.setValue(3.5) ;
                    }
                }else if(elect === "AUTOMATIC_SALT_AS7"){
                    if(volume < 65){
                        spaSaltRateEl.setValue(2) ;
                    }else{
                        spaSaltRateEl.setValue(3.5) ;
                    }
                }else if(elect === "SALT_RELAX_PLUS"){
                    spaSaltRateEl.setValue(4) ;
                }else if(elect === "SALT_RELAX_POWER"){
                    if(volume < 65){
                        spaSaltRateEl.setValue(2) ;
                    }else{
                        spaSaltRateEl.setValue(3.5) ;
                    }
                }else{
                    spaSaltRateEl.setValue("") ;
                }
            }
            spaElectEl.addEventListener("change", onChange) ;
            spaVolumeEl.addEventListener("change", onChange) ;
            view.on("render", function(){
                spaElectEl.setOptions(computeOptions()) ;
            }) ;
        }   


    }) ;
} ;




module.exports = extension ;